import Header from './Header';
import Element from './Element';

function Mix() {
    return (
        <div>
            <div className="page">
                <a className="return" href={`${process.env.PUBLIC_URL}/`}><i class="fa-solid fa-left-long"></i></a>
                <div className="box">
                    <h1 className="nonimage-h1">ボーカルMIX</h1>
                    <p>ボーカルMIXを担当したものを掲載しています。</p>
                    <div className="items">
                        <p><span>Studio One</span></p>
                    </div>
                </div>
                <div className="content">
                    {Element("https://img.youtube.com/vi/rS50CdTWaSc/mqdefault.jpg", "毒して頂戴", "作詞・作曲: なきそ ボーカル: るぅ", "https://www.youtube.com/watch?v=rS50CdTWaSc", true)}
                    {Element("https://img.youtube.com/vi/nK1iMmH0TqI/mqdefault.jpg", "きゅうくらりん", "作詞・作曲: いよわ ボーカル: るぅ", "https://www.youtube.com/watch?v=nK1iMmH0TqI", true)}
                    {Element("https://img.youtube.com/vi/l2UvKSXly5E/mqdefault.jpg", "へべれけジャンキー", "作詞・作曲: syudou ボーカル: ユズキ", "https://www.youtube.com/watch?v=l2UvKSXly5E", true)}
                    {Element("https://img.youtube.com/vi/TxBjA54mxSw/mqdefault.jpg", "らくらく安楽死", "作詞・作曲: ぺぽよ ボーカル: 黒柩壱華  - 公開終了", "https://www.youtube.com/watch?v=TxBjA54mxSw", true)}
                    {Element("https://img.youtube.com/vi/VNF4HZdDzbY/mqdefault.jpg", "バグ", "作詞・作曲: かいりきベア ボーカル: アリア・ウォーカー&黒柩壱華  - 公開終了", "https://www.youtube.com/watch?v=VNF4HZdDzbY", true)}
                    {Element("https://img.youtube.com/vi/ovCEG47OjvY/mqdefault.jpg", "コールボーイ", "作詞・作曲: syudou ボーカル: ユズキ", "https://www.youtube.com/watch?v=ovCEG47OjvY", true)}
                    {Element("https://img.youtube.com/vi/U09Zm0Uj4r0/mqdefault.jpg", "ネロイズム", "作詞・作曲: かいりきベア ボーカル: ユズキ", "https://www.youtube.com/watch?v=U09Zm0Uj4r0", true)}
                    {Element("https://img.youtube.com/vi/h3gtNMF_Pao/mqdefault.jpg", "ロキ", "作詞・作曲: みきとP ボーカル: ユズキ", "https://www.youtube.com/watch?v=h3gtNMF_Pao", true)}
                </div>
                <div className="box">
                    <h2>MIXのご依頼について</h2>
                    <p>ただいま多忙につき、知人からのMIX依頼のみ受け付けております。<br />新規にご依頼を頂いても対応できませんのでご了承ください。</p>
                </div>
            </div>
        </div>
    )
}

export default Mix;